/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Loading_Aria_LabelInputs */

const en_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading clipboard content`)
};

const fr_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du contenu du presse-papiers`)
};

const de_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt der Zwischenablage wird geladen`)
};

const it_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del contenuto degli appunti`)
};

const ru_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка содержимого буфера обмена`)
};

const es_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando contenido del portapapeles`)
};

const zh_cn2_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载剪贴板内容`)
};

const ja_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリップボードの内容を読み込み中`)
};

const hi_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लिपबोर्ड की सामग्री लोड हो रही है`)
};

const pt_pt2_paste_attributes_loading_aria_label = /** @type {(inputs: Paste_Attributes_Loading_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando conteúdo da área de transferência`)
};

/**
* | output |
* | --- |
* | "Loading clipboard content" |
*
* @param {Paste_Attributes_Loading_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_loading_aria_label = /** @type {((inputs?: Paste_Attributes_Loading_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Loading_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_loading_aria_label(inputs)
	if (locale === "de") return de_paste_attributes_loading_aria_label(inputs)
	if (locale === "it") return it_paste_attributes_loading_aria_label(inputs)
	if (locale === "ru") return ru_paste_attributes_loading_aria_label(inputs)
	if (locale === "es") return es_paste_attributes_loading_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_loading_aria_label(inputs)
	if (locale === "ja") return ja_paste_attributes_loading_aria_label(inputs)
	if (locale === "hi") return hi_paste_attributes_loading_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_loading_aria_label(inputs)
	return en_paste_attributes_loading_aria_label(inputs)
});